var render, staticRenderFns
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48c4153e')) {
      api.createRecord('48c4153e', component.options)
    } else {
      api.reload('48c4153e', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/rights/fee/dealer_balance/form/form.vue"
export default component.exports